import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./MainNavigation.css";

const MainNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: "my-prompt",
      label: "My Prompt",
      icon: "✏️",
      description: "Create and manage your prompts",
    },
    {
      id: "all-prompts",
      label: "All Prompts",
      icon: "📊",
      description: "Browse, filter, and manage all submitted prompts.",
    },
    {
      id: "my-library",
      label: "My Library",
      icon: "📁",
      description: "Access all your generated content",
    },
  ];

  return (
    <div className="main-navigation">
      <div className="nav-container">
        <div className="nav-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => onTabChange(tab.id)}
            >
              <div className="tab-icon">{tab.icon}</div>
              <div className="tab-content">
                <div className="tab-label">{tab.label}</div>
                <div className="tab-description">{tab.description}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainNavigation;
